import { FC } from "react";
import { Stack } from "@chakra-ui/react";

import { FrontendUnexpectedErrorIcon } from "../../../icons/errors";
import { ErrorTemplate } from "../blocks/ErrorTemplate.tsx";

export const FrontendUnexpectedError: FC = () => {
  const message = "Произошла непредвиденная ошибка";
  const additionalMessage = "Пожалуйста,"
    + " попробуйте повторить действие позже или перезагрузите страницу";

  return (
    <Stack mt="20px">
      <ErrorTemplate
        error={null}
        icon={FrontendUnexpectedErrorIcon}
        message={message}
        additionalMessage={additionalMessage}
      />
    </Stack>
  );
};
